import React, { useState } from 'react';
import './Navbar.css';
import image1 from '../../assets/Hruthi AI EdTech.png';
import { useNavigate } from 'react-router-dom';
import SignUp from '../../components/SignUp/SignUp';
import { FaBars } from "react-icons/fa";

const Navbar = () => {
  const navigate = useNavigate();
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isSignedUp, setIsSignedUp] = useState(false); // New state to track sign-up status
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const openSignUp = () => setIsSignUpOpen(true);
  const closeSignUp = () => setIsSignUpOpen(false);

  return (
    <>
      <nav className="navbar-main">
        <img
          src={image1}
          alt="Logo"
          className="navbar-logo"
          onClick={() => navigate('/')}
        />
        <button
          className="hamburger-menu"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <FaBars />
        </button>

        <ul className={`navbar-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <li onClick={() => navigate('')}>Home</li>
          <li
            className="dropdown"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            Programs
            {isDropdownOpen && (
              <ul className="dropdown-menu">
                <li onClick={() => navigate('/programs/fullstack')}>FullStack ReactJs with AI</li>
                <li onClick={() => navigate('/programs/cybersecurity')}>Cyber Security Expert with AI</li>
                <li onClick={() => navigate('/programs/data-science')}>Data Science with AI & ML</li>
                <li onClick={() => navigate('/programs/data-analytics')}>Data Analytics with AI</li>
              </ul>
            )}
          </li>
          <li>Placements</li>
          <li onClick={() => navigate('/contact')}>Contact</li>
          <li onClick={() => navigate('/webinar')}>Webinar</li>
          <li>
            {!isSignedUp && ( // Hide the button when signed up
              <button className="navbar-button navbar-mobile-button" onClick={openSignUp}>
                Sign Up
              </button>
            )}
          </li>
        </ul>

        {!isSignedUp && ( // Hide the button when signed up
          <button className="navbar-button navbar-web-button" onClick={openSignUp}>
            Sign Up
          </button>
        )}
      </nav>

      <SignUp isOpen={isSignUpOpen} onClose={closeSignUp} setIsSignedUp={setIsSignedUp} />
    </>
  );
};

export default Navbar;
